var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CollapsiblePanel',{staticClass:"rules-title",attrs:{"variant":['default', 'rounded', '30-12-paddings'],"label":_vm.$t(
      '_web_tournament_additional_settings_licenseAgreement',
      'License Agreement'
    )}},[_c('div',{staticClass:"rules-section-custom-wrapper"},[_c('div',{staticClass:"row mb-5"},[_c('SettingsLicenseText',{staticClass:"col-8 rules-text"})],1),_c('div',{staticClass:"row no-gutters rules-file"},[_c('SettingsLicenseFile',{staticClass:"col-3"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }